// extracted by extract-css-chunks-webpack-plugin
module.exports = {"icon":"_29c3tu","panelContainer":"fdmKdx","title":"_2dF0hQ","generateOutlineAttributes":"_1S_be3","body":"_3OjEgL"};